import React from "react";
import { connect } from "react-redux";
import { IAppState } from "../../state/Store";
import "./CommonToolbar.scss";

interface CommonToolbarProps {
    sidebarPinned: boolean;

    appsOpen: boolean;
    notificationsOpen: boolean;
    settingsOpen: boolean;

    userIsNotified: boolean;
    userIsNotifiedEm: boolean;

    elevioIdentifier: number;

    imports: number;
    uploads: number;
    unread: number;
    newUnread: boolean;
    displayClicked: Function;
    shareClicked: Function;
    appsClicked: Function;
    notificationsClicked: Function;
    settingsClicked: Function;
}

class CommonToolbar extends React.Component<CommonToolbarProps> {
    openElevio = () => {
        if (!window["elevioOpen"]) {
            if (this.props.elevioIdentifier > 0) {
                window["_elev"].openArticle(this.props.elevioIdentifier);
            } else {
                window["_elev"].openHome();
            }
        } else {
            window["_elev"].close();
        }
    };
    showDisplaySettings = () => this.props.displayClicked();
    showShare = () => this.props.shareClicked();
    showApps = () => this.props.appsClicked();
    showNotifications = () => this.props.notificationsClicked();
    settingsClicked = () => this.props.settingsClicked();

    hasNotifications() {
        return this.props.newUnread;
    }

    render() {
        return (
            <div className="common-toolbar">
                <button
                    onClick={this.openElevio}
                    data-place="left"
                    data-tip="Open help & support">
                    <i>help</i>
                </button>
                <button
                    onClick={this.showDisplaySettings}
                    data-place="left"
                    data-tip="Open display settings"
                    tabIndex={this.props.sidebarPinned ? 0 : -1}>
                    <i>display_settings</i>
                </button>
                <button
                    onClick={this.showShare}
                    data-place="left"
                    data-tip="Open the share dialog"
                    tabIndex={this.props.sidebarPinned ? 0 : -1}>
                    <i>ios_share</i>
                </button>
                <button
                    className={this.props.appsOpen ? "open" : ""}
                    onClick={this.showApps}
                    data-place="left"
                    data-tip="View apps"
                    tabIndex={this.props.sidebarPinned ? 0 : -1}>
                    <i>apps</i>
                </button>
                <button
                    className={`${this.props.notificationsOpen ? "open" : ""} ${
                        this.hasNotifications() ? "notification" : ""
                    } ${this.props.userIsNotifiedEm ? "emphasized" : ""}`}
                    onClick={this.showNotifications}
                    data-place="left"
                    data-tip="View notifications"
                    tabIndex={this.props.sidebarPinned ? 0 : -1}>
                    <i>notifications</i>
                </button>
                <button
                    className={this.props.settingsOpen ? "open" : ""}
                    onClick={this.settingsClicked}
                    data-place="left"
                    data-tip="Configure settings"
                    tabIndex={this.props.sidebarPinned ? 0 : -1}>
                    <i>settings_applications</i>
                </button>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState) => {
    const { imports, uploads, messaging, ui } = state.db;
    return {
        imports: imports.imports?.length ?? 0,
        uploads: uploads.uploads?.length ?? 0,
        unread: messaging.unread?.length ?? 0,
        newUnread: messaging.newUnread ?? false,
        sidebarPinned: ui.sidebarPinned,

        userIsNotified: false,
        userIsNotifiedEm: false,

        elevioIdentifier: 0,
    };
};

const mapDispatchToProps = dispatch => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(CommonToolbar);
